import React from 'react';
import { connect } from 'react-redux';
import {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace} from '../actions/race';
import Loading from './Loading';
import SearchSmallIcon from '../icons/search-small';

class MobileSearch extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  state = {
    search: '',
    hasSearched: false
  };

  componentDidMount() {

    this.props.syncFavorites(this.props.match.params.raceId);
    if (this.props.match.params.raceId) {
      this.props.getRaceDetails(this.props.match.params.raceId);
    }
  }

  componentDidUpdate(oldProps){

    if (this.props.match.params.raceId !== oldProps.match.params.raceId) {
      this.props.switchRace(this.props.match.params.raceId);
      this.setState({search: '', hasSearched: false});
    }
  }

  handleSearchChange(e) {
    e.preventDefault();
    this.setState({search: e.target.value});
  }

  handleSearch(e) {
    e.preventDefault();
    if (isNaN(parseInt(this.state.search))) {
      this.props.performSearch(this.state.search, 'ALL', 0, '*');
      this.setState({hasSearched: true});
    } else {
      this.navigateToRunner(parseInt(this.state.search));
    }
  }

  navigateToRunner(search) {
    this.props.history.push(`/race/${this.props.raceDetail.race_id}//${search}`);
  }


  render() {

    const {raceDetail} = this.props;

    console.log(this.props);

    if (!raceDetail || !raceDetail.name) return null;

    return (
      <div>
        <div className="header">
          <h5 className="title" style={{backgroundColor: this.props.color}}>{raceDetail.name}</h5>

          <div className="info-block clearfix">
            <h3>Athlete Search</h3>

            <a href={`#/race/${raceDetail.race_id}`} className="btn menubutton">Menu</a>
          </div>
        </div>
        <form onSubmit={this.handleSearch.bind(this)}>
          <div className="form-search clearfix">



            <p>
              <label htmlFor="input-search" className="hidden">Search for:</label>
              <input id="input-search" type="text" value={this.state.search} className="field-search" onChange={this.handleSearchChange.bind(this)} />
              <button className="btn-search" onClick={this.handleSearch.bind(this)}><SearchSmallIcon /></button>
            </p>



          </div>

          <div className="buttons">
            <div className="buttons-outer">
              <div className="buttons-inner clearfix">
                <a className="button-clear" onClick={() => {this.setState({hasSearched: false});}}>Clear</a>
                <a className="button-search" onClick={this.handleSearch.bind(this)}><span>Search</span></a>
              </div>
            </div>
          </div>
        </form>

        <div className="entries">
          {!this.state.hasSearched ? (
            <p>&nbsp;</p>
          ) : (
            <div>
              {this.props.searchResults === undefined || this.props.searchResults === null ? (
                <Loading />
              ) : (
                <div>
                  {this.props.searchResults.length === 0 &&
                    <div className="no-results">No results found</div>
                  }
                  {this.props.searchResults.map((runner, idx) => (
                    <div className="entry" data-id="{{this.ENTRY_ID}}" key={idx}>
                      <div className="entry-inner clearfix">
                        <div className="entry-text">
                          <p><a href={`#/race/${raceDetail.race_id}//${runner.$KEY}`}>
                            {runner.TEAM_NAME  ? (<span>{runner.TEAM_NAME}</span>) : (<span>{`${runner.$FIRST_NAME} ${runner.$LAST_NAME}`}</span>)}
                            {runner.CITY && <span>{runner.CITY}</span>}
                            {runner.STATE && <span>{runner.STATE}</span>}
                          </a></p>
                        </div>
                        <p className="entry-count"><a href={`#/race/${raceDetail.race_id}//${runner.$KEY}`}>Bib: {runner.$KEY}</a></p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

        </div>
      </div>
    );

    //   return (
    //   <div>
    //     <div className="intro clearfix">
    //       {/*<div className="intro-image hide">*/}
    //         {/*<a href="#">*/}
    //           {/*<img src="../styles/images/temp/intro.jpg" alt="" />*/}
    //         {/*</a>*/}
    //       {/*</div>*/}
    //
    //       <div className="intro-inner">
    //         <div className="intro-content">
    //           <h3 className="intro-title">
    //             <a href="#">{raceDetail.name}</a>
    //           </h3>
    //
    //           <p className="intro-meta">
    //             {raceDetail.event_date} &nbsp; {`${raceDetail.city}, ${raceDetail.state}`}
    //           </p>
    //         </div>
    //
    //         <div className="socials">
    //           {/*<ul>*/}
    //             {/*<li>*/}
    //               {/*<a href="#" className="link-facebook">facebook</a>*/}
    //             {/*</li>*/}
    //
    //             {/*<li>*/}
    //               {/*<a href="#" className="link-twitter">twitter</a>*/}
    //             {/*</li>*/}
    //
    //             {/*<li>*/}
    //               {/*<a href="#" className="link-google">google</a>*/}
    //             {/*</li>*/}
    //           {/*</ul>*/}
    //         </div>
    //       </div>
    //     </div>
    //
    //     <div className="nav">
    //       <ul className="clearfix">
    //         <li className={`eventTab ${this.state.selectedTab === 'leader' ? 'current' : ''}`} data-tabid="leader" onClick={this.updateTab.bind(this, 'leader')}>
    //           <span href="#">Leaderboard</span>
    //         </li>
    //
    //         <li id="tab-results" className={`eventTab ${this.state.selectedTab === 'results' ? 'current' : ''}`} data-tabid="results"  onClick={this.updateTab.bind(this, 'results')}>
    //           <span href="#">Results</span>
    //         </li>
    //
    //         <li className={`eventTab last ${this.state.selectedTab === 'favorites' ? 'current' : ''}`} data-tabid="favorites" onClick={this.updateTab.bind(this, 'favorites')}>
    //           <span href="#">Favorites</span>
    //         </li>
    //
    //         <li className={`eventTab ${this.state.selectedTab === 'questions' ? '' : ''}`} data-tabid="questions" onClick={this.updateTab.bind(this, 'questions')}>
    //           <span className="link-red" href="#">Questions About Results?</span>
    //         </li>
    //       </ul>
    //     </div>
    //
    //     <div className="main">
    //       <div id="tabContent">
    //         <ResultsHeader history={this.props.history} onSearch={this.handleSearch.bind(this)}/>
    //
    //         {this.state.selectedTab === 'leader' &&
    //           <Leaderboard history={this.props.history} updateTab={this.updateTab.bind(this)} />
    //         }
    //
    //         {this.state.selectedTab === 'results' &&
    //           <Results history={this.props.history} />
    //         }
    //
    //         {this.state.selectedTab === 'favorites' &&
    //           <Favorites history={this.props.history} />
    //         }
    //
    //         {this.state.selectedTab === 'questions' &&
    //           <Question history={this.props.history} />
    //         }
    //
    //         {this.state.selectedTab === 'searchResults' &&
    //           <SearchResults history={this.props.history} />
    //         }
    //
    //       </div>
    //     </div>
    //   </div>
    // );
  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    searchResults: state.rr360.searchResults,
    resultsTotal: state.rr360.searchResultsTotal,
    resultsPage: state.rr360.searchResultsPage,
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace})(MobileSearch);



// WEBPACK FOOTER //
// ./src/components/MobileSearch.js